import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import Sidebar from "../sidebar/SideBar";
import Header from "../header/Header";

interface DashBoardLayoutProps {
  logo?: string;
  children?: ReactNode;
}

const DashBoardLayout: React.FC<DashBoardLayoutProps> = ({
  logo,
  children,
}) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar logo={logo} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: "auto",
          bgcolor: "#E7E7E7",
          minHeight: "100vh",
        }}
      >
        <Header />
        {children}
      </Box>
    </Box>
  );
};

export default DashBoardLayout;
